"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTabs = void 0;
const react_1 = require("react");
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const Tab_1 = require("./Tab");
const tabUtils_1 = require("./tabUtils");
const BaseTabs = (props) => {
    var _a, _b, _c;
    const location = react_router_dom_1.useLocation();
    const history = react_router_1.useHistory();
    const baseMatch = react_router_1.useRouteMatch(props.baseRoute);
    const [activeTab, setActiveTab] = React.useState(getCurrentActiveTab());
    const lastNumberOfTabs = react_1.useRef(props.tabs.length);
    const widthRef = react_1.useRef(null);
    const [defaultWidthAvailable, setDefaultWidthAvailable] = React.useState(0);
    // Width of add button
    const addTabButtonWidth = 63;
    // Width available for tabs without add button
    const availableTabsWidth = ((_a = props.customWidthAvailable) !== null && _a !== void 0 ? _a : defaultWidthAvailable)
        - (props.isDynamicTabs ? addTabButtonWidth : 0);
    // Max width per tab
    const calculatedMaxTabWidth = availableTabsWidth / props.tabs.length;
    const maxTabWidth = props.customMaxTabWidth && calculatedMaxTabWidth > props.customMaxTabWidth ?
        props.customMaxTabWidth : calculatedMaxTabWidth;
    // Default to disable add button when no more space for tabs
    const disableButtonWhenNoSpace = (_b = props.disableAddButtonWhenNoSpace) !== null && _b !== void 0 ? _b : true;
    // Calculate if add button should be disabled
    const addButtonDisabled = (_c = props.disableNewTab) !== null && _c !== void 0 ? _c : (disableButtonWhenNoSpace ? maxTabWidth < 50 : false);
    const getAvailableWidth = () => {
        if (widthRef.current) {
            const overflowWidth = document.body.scrollWidth > document.body.offsetWidth ?
                (document.body.scrollWidth - document.body.offsetWidth) : 0;
            return widthRef.current.offsetWidth - overflowWidth;
        }
        return 0;
    };
    React.useEffect(() => {
        setActiveTab(getCurrentActiveTab());
    }, [location]);
    React.useEffect(() => {
        if (!props.customWidthAvailable) {
            setDefaultWidthAvailable(getAvailableWidth);
            window.addEventListener('resize', () => setDefaultWidthAvailable(getAvailableWidth));
            return () => window.removeEventListener('resize', () => setDefaultWidthAvailable(getAvailableWidth));
        }
        else {
            return;
        }
    }, []);
    React.useEffect(() => {
        // This useEffect is for DynamicTabs only.
        // The first if statement runs if the number of tabs has changed, so a tab has either been added or removed.
        if (lastNumberOfTabs.current !== props.tabs.length) {
            // This if statement runs if a tab has been added, in that case you should be rerouted/pushed to the
            // new route (aka the last tab in props.tabs) OR if the active tab no longer exists in props.tabs, which means you
            // removed the tab you were currently on and should then be rerouted/pushed to the last tab in the array.
            if (lastNumberOfTabs.current < props.tabs.length || !props.tabs.find((tab) => tab.route === activeTab.route)) {
                history.push(`/${getCurrentBaseUrl()}/${props.tabs[props.tabs.length - 1].route}`);
            }
            lastNumberOfTabs.current = props.tabs.length;
        }
    }, [props.tabs.length]);
    const { handleKeyDown, setTabRefs } = tabUtils_1.useTabController(props.tabs.length);
    function getCurrentActiveTab() {
        const index = props.tabs.findIndex((tab) => {
            var _a;
            const match = react_router_1.matchPath(location.pathname, { exact: (_a = props.exactMatch) !== null && _a !== void 0 ? _a : true, path: `${props.baseRoute}/${tab.route}` });
            return match !== null;
        });
        return props.tabs[index >= 0 ? index : 0];
    }
    function getCurrentBaseUrl() {
        const locationPaths = location.pathname.split('/').filter((path) => path);
        return locationPaths.splice(0, locationPaths.length - 1).join('/');
    }
    const containerType = props.layout ? props.layout : 'box';
    return (React.createElement("div", { className: "base-tabs" },
        React.createElement("div", { role: "tablist", className: `tab-list tab-list-${containerType}`, onKeyDown: handleKeyDown, ref: widthRef },
            containerType === 'fluid' && React.createElement("div", { className: "tab-content-box-top-shadow" }),
            props.tabs.map((tab, index) => {
                return (React.createElement(Tab_1.Tab, { key: tab.title + index, title: tab.title, route: `${baseMatch === null || baseMatch === void 0 ? void 0 : baseMatch.url}/${tab.route}`, setTabRef: (ref) => {
                        setTabRefs(index, ref);
                    }, active: activeTab.route === tab.route, isDynamicTab: props.isDynamicTabs, closeTab: props.closeTab, index: index, maxWidth: maxTabWidth, tabsLength: props.tabs.length, icon: tab.icon }));
            }),
            props.isDynamicTabs &&
                React.createElement("button", { className: "add-new-tab-button", onClick: addButtonDisabled ? undefined : props.openNewTab, disabled: addButtonDisabled, type: "button" },
                    React.createElement(Icon_1.default, { icon: "plus" }))),
        React.createElement("div", { tabIndex: 0, id: `tabpanel_${activeTab.title}`, role: "tabpanel", "aria-labelledby": `tab_${activeTab.title}`, "aria-hidden": "false", className: `tab-content-${containerType}` },
            React.createElement(react_router_1.Switch, null,
                props.tabs.map((tab) => {
                    var _a;
                    return React.createElement(react_router_1.Route, { key: tab.title, exact: (_a = props.exactMatch) !== null && _a !== void 0 ? _a : true, path: `${props.baseRoute}/${tab.route}`, render: tab.tabContent });
                }),
                React.createElement(react_router_1.Redirect, { to: `${props.baseRoute}/${activeTab.route}` })))));
};
exports.BaseTabs = BaseTabs;
//# sourceMappingURL=BaseTabs.js.map